import { Button, Form, Input, Modal, Select } from 'antd';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { STATUS } from 'constants/reponseStatus';
import { IPermissionGroup, IUser } from 'interface/user.interface';
import { mockRoleGroupUser, mockRoleUser } from 'mock/route-mangagement';
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import handleError401 from 'utils/handleError401';
import { openNotificationWithIcon } from 'utils/notification';

const { Option } = Select;

interface IProps {
  isModalVisible: boolean;
  onCancel: () => void;
  handleUpdateUser: (data: any) => void;
  currentUser?: IUser;
  groups?: IPermissionGroup[];
  isLoading: boolean;
}

const formLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export default function UserModal(props: IProps): JSX.Element {
  const {
    isModalVisible,
    onCancel,
    handleUpdateUser,
    currentUser,
    groups,
    isLoading,
  } = props;

  const [roles, setRoles] = useState([]);
  const [disablePlant, setDisablePlant] = useState(false);

  const [form] = Form.useForm();

  // const { mutate: getRoles } = useMutation(
  //   ['getRoles'],
  //   () => RoleBasedAuth.getRoles(),
  //   {
  //     onSuccess: (response: any) => {
  //       if (response.status === STATUS.SUCCESS) {
  //         setRoles(response?.data);
  //       }
  //     },
  //     onError: (error: any) => {
  //       openNotificationWithIcon('error', error.toString());
  //     },
  //   }
  // );

  useEffect(() => {
    const user = {
      ...currentUser,
      plantCodesManaging: currentUser?.plantCodesManaging?.join(';'),
    };
    form.setFieldsValue(user);
    setDisablePlant(!currentUser?.role?.includes('asm'));
  }, [currentUser, form]);

  // useEffect(() => {
  //   getRoles();
  // }, []);

  return (
    <Modal
      title="Phân quyền người dùng"
      visible={isModalVisible}
      onCancel={onCancel}
      footer={null}
      centered={true}
    >
      <Form
        form={form}
        name="role_based_auth"
        onFinish={handleUpdateUser}
        className="bg-white p-2 gap-4 lg:w-90 md:w-90 sm:w-100"
        initialValues={currentUser}
        {...formLayout}
        labelAlign="left"
      >
        <Form.Item label="Mã nhân viên" name="id">
          <Input size="small" disabled style={{ padding: '9px 10px' }} />
        </Form.Item>

        <Form.Item label="Họ và Tên" name="fullName">
          <Input size="small" style={{ padding: '9px 10px' }} disabled />
        </Form.Item>

        <Form.Item label="Email" name="email">
          <Input size="small" style={{ padding: '9px 10px' }} disabled />
        </Form.Item>

        <Form.Item label="Điện thoại" name="phoneNumber">
          <Input size="small" style={{ padding: '9px 10px' }} disabled />
        </Form.Item>

        <Form.Item className="hidden" name="jobTitleCode">
          <Input
            size="small"
            style={{ padding: '9px 10px' }}
            className="hidden"
          />
        </Form.Item>

        <Form.Item label="Chức vụ" name="jobTitle">
          <Input size="small" style={{ padding: '9px 10px' }} disabled />
        </Form.Item>

        <Form.Item label="Tên bộ phận/Cửa hàng" name="departmentName">
          <Input
            size="small"
            style={{ padding: '9px 10px' }}
            className="w-full"
            disabled
          />
        </Form.Item>
        <Form.Item label="Plant" name="plantCode">
          <Input
            size="small"
            style={{ padding: '9px 10px' }}
            className="w-full"
          />
        </Form.Item>

        <Form.Item label="Plant quản lý" name="plantCodesManaging">
          <Input
            size="small"
            style={{ padding: '9px 10px' }}
            className="w-full"
            disabled={disablePlant}

            // disabled={!currentUser?.role.includes('asm')}
          />
        </Form.Item>
        <Form.Item label="Quyền vào hệ thống" name="groups">
          <Select defaultValue={currentUser?.groups} allowClear>
            {/* {groups?.map((group) => (
              <Option key={group.name} value={group.name}>
                {group.title}
              </Option>
            ))} */}
            {mockRoleGroupUser?.map((group) => (
              <Option key={group?.id} value={group?.value}>
                {group?.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Các quyền" name="role">
          <Select
            defaultValue={currentUser?.role}
            allowClear
            onChange={() => {
              if (!form.getFieldValue('role')?.includes('asm')) {
                form.setFieldValue('plantCodesManaging', '');
              }
              setDisablePlant(!form.getFieldValue('role')?.includes('asm'));
            }}
          >
            {mockRoleUser?.map((group) => (
              <Option key={group?.id} value={group?.value}>
                {group?.title}
              </Option>
            ))}

            {/* {roles?.map((group) => (
              <Option key={group?.id} value={group?.role}>
                {group?.role_name}
              </Option>
            ))} */}
          </Select>
        </Form.Item>

        <Form.Item className="flex items-center justify-center">
          <Button
            disabled={isLoading}
            type="primary"
            htmlType="submit"
            className="bg-primary"
          >
            CHỈNH SỬA
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
